export default "__VITE_ASSET__dgevW0Fb__"